import React from "react";
import PropTypes from "prop-types";
import ErrorBoundary from "../error_boundary";
import GetQwotedCTA from "../profiles/GetQwotedCTA";
import Expert from "./Expert";
import { ExpertProvider } from "./data/expert_context_management";

// Registered entry point for the Expert show page (mirrors PrProfileTopLevelShow): wraps the provider
// + error boundary around the show. The ERB mounts this component by name.
function ExpertTopLevelShow({ expertId, viewerContext = undefined }) {
  const contextValue = { viewerContext };

  return (
    <ExpertProvider value={contextValue}>
      <ErrorBoundary>
        <Expert expertId={expertId} />
      </ErrorBoundary>
      {!viewerContext?.isAuthenticated && <GetQwotedCTA />}
    </ExpertProvider>
  );
}

ExpertTopLevelShow.propTypes = {
  expertId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  viewerContext: PropTypes.shape({
    editable: PropTypes.bool,
    isSelf: PropTypes.bool,
    // Authority over the promoter profile behind a self-representing expert — a strictly narrower
    // question than `editable`, and false for every viewer when there is no such profile.
    profileEditable: PropTypes.bool,
    isAuthenticated: PropTypes.bool,
    role: PropTypes.string,
  }),
};

export default ExpertTopLevelShow;
